/* Real-time stock guard (product page) — LIVE-safe build: refresh-on-view + messaging only.
   On load it asks our server to scrape THIS product live and push the fresh per-variant
   stock into Shopify. That makes Shopify's own inventory accurate, so Shopify's native
   "deny" policy hard-blocks over-buying at Add-to-Cart and greys out sold-out sizes.
   This script then just shows a friendly "Only X left" / "just sold out" note.
   No Add-to-Cart interception, so it cannot disrupt the buy flow. */
(function () {
  var PID = window.__SG_PID;
  if (!PID) return;
  var HOST = "https://stock." + location.hostname.replace(/^www\./, "");
  var fresh = null; // { variantId(str): qty } for live (HTTP) vendors

  function forms() { return Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]')); }
  function primary() { return forms()[0]; }
  function vidOf(f) { var el = f && f.querySelector('[name="id"]'); return el ? String(el.value) : null; }
  function have(vid) { return (fresh && vid in fresh) ? fresh[vid] : undefined; }

  fetch(HOST + "/stock?pid=" + encodeURIComponent(PID), { mode: "cors", credentials: "omit" })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      fresh = {};
      if (d && d.pushed && d.pushed.variants) d.pushed.variants.forEach(function (v) { fresh[String(v.variantId)] = v.newQty; });
      applyUI();
    })
    .catch(function () { /* network/CORS issue -> silently rely on Shopify's cadence number */ });

  function applyUI() {
    var f = primary(); if (!f || !fresh) return;
    var h = have(vidOf(f)); clearMsg();
    if (h === undefined) return;            // cadence vendor or unknown variant -> no note
    if (h < 1) msg("This size just sold out at our supplier.", true);
    else if (h <= 3) msg("Only " + h + " left.", false);
  }
  // re-evaluate when the shopper switches size/color (theme updates the hidden id input)
  var last = null;
  setInterval(function () { var f = primary(); var v = f ? vidOf(f) : null; if (v !== last) { last = v; applyUI(); } }, 400);

  function msg(t, warn) {
    var f = primary(); if (!f) return;
    var d = document.getElementById("sg-msg");
    if (!d) { d = document.createElement("div"); d.id = "sg-msg"; d.style.cssText = "margin:8px 0;font-size:13px;font-weight:600;line-height:1.3"; f.insertBefore(d, f.firstChild); }
    d.textContent = t; d.style.color = warn ? "#b00020" : "#666";
  }
  function clearMsg() { var d = document.getElementById("sg-msg"); if (d) d.textContent = ""; }
})();
